








































import { Component, Vue, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";

@Component
export default class SelectUniqueInsertDialog extends Vue {
  @Ref("new-survey-address-dialog")
  dialog!: QDialog;

  newValue = "";

  onSubmit() {
    if (this.newValue) {
      this.$emit("ok", this.newValue);
      this.hide();
    }
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
